import type { ReactNode } from 'react';
import { ModalOverlay } from '../components/ModalOverlay.js';

export function InfoModal({ title, onClose, children }: { title: string; onClose: () => void; children: ReactNode }) {
  return (
    <ModalOverlay role="dialog" aria-modal="true" aria-label={title}
      className="z-50 bg-ink-900/60"
      onClick={(e) => { if (e.target === e.currentTarget) onClose(); }}>
      <div className="max-w-md w-full rounded-lg bg-canvas-light dark:bg-canvas-dark p-6 shadow-lg ring-1 ring-ink-900/10 dark:ring-white/10"
        onClick={(e) => e.stopPropagation()}>
        <h2 className="h-card text-ink-900 dark:text-ink-100">{title}</h2>
        <div className="mt-3 text-sm text-ink-700 dark:text-ink-300 space-y-3">{children}</div>
        <div className="mt-5 flex justify-end">
          <button type="button" onClick={onClose} className="btn-primary">Close</button>
        </div>
      </div>
    </ModalOverlay>
  );
}
